import {User} from 'src/openapi/models/User';

export const getUserName = (userEmail: string, user: User | null) => {
    return user ? `${user.firstName} ${user.lastName}` : userEmail;
};
